import { usePersonalInformation } from '@/hooks/usePersonalInformation';

export type Phase =
	| 'form'
	| 'verifying'
	| 'unsuccessful'
	| 'failed'
	| 'successful';

export type PersonalInformationReturn = ReturnType<
	typeof usePersonalInformation
>;

export const VERIFYING_DURATION_MS = 6000;
